export default {"src":"/_next/static/media/check_circle.f1116283.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};